import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import AppRoutes from "./AppRoutes/AppRoutes";
import LoadingComponent from "./Components/LoadingComponent/LoadingComponent";
import useAuth from "./API/useAuth";
import CustomSnackbar from "./Components/Snackbar/Snackbar";
import "./styles.css"
function App() {
  const [theme, colorMode] = useMode();
  if (localStorage.getItem("Manager-token") && !sessionStorage.getItem("Manager-token")) {
    sessionStorage.setItem("Manager-token", localStorage.getItem("Manager-token"));
  
  }
  const { loading } = useAuth(localStorage.getItem("Manager-token"));

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
          >
            <LoadingComponent thickness={5} size="6em" color="primary" />
          </Box>
        )}
        {!loading && (
          <div
            className="app"
            style={{ display: "flex", height: "100vh", overflow: "hidden" }}
          >
            <AppRoutes />
          </div>
        )}
        <CustomSnackbar />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
export default App;
